const exists = (x) => {
  if (typeof x === "undefined" || x === null) {
    return false;
  }
  return true;
};

export default exists;
